import React from 'react';
import classNames from 'classnames';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  count: number;
}

export const GridItemCount: React.FC<Props> = ({ count, className, ...rest }) => (
  <span className={classNames('GridItemCount', className)} {...rest}>
    {count} Item{count === 1 ? '' : 's'}
  </span>
);
